
import React from "react";
import { MapPin, Phone, Mail, Clock } from "lucide-react";

const locations = [
  {
    city: 'Mumbai',
    address: 'Tech Park, Andheri East, Mumbai - 400069',
    phone: '022 6962 1901',
    email: 'support@truecoregadgets.com',
    hours: 'Mon-Fri: 9AM-6PM'
  },
  {
    city: 'Delhi',
    address: 'Cyber Hub, Gurugram, Delhi NCR - 122002',
    phone: '022 6962 1901',
    email: 'support@truecoregadgets.com',
    hours: 'Mon-Fri: 9AM-6PM'
  },
  {
    city: 'Hyderabad',
    address: 'Tech Avenue, Madhapur, Hyderabad - 500081',
    phone: '022 6962 1901',
    email: 'support@truecoregadgets.com',
    hours: 'Mon-Fri: 9AM-6PM'
  }
];

const ContactLocations = () => (
  <div className="space-y-6">
    <h3 className="text-2xl font-bold mb-2">Our Locations</h3>
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      {locations.map((location, index) => (
        <div key={index} className="bg-white p-5 rounded-lg shadow-sm border border-border/50">
          <h4 className="text-lg font-bold mb-3">{location.city} Office</h4>
          <div className="space-y-3">
            <div className="flex items-start space-x-3">
              <MapPin className="text-primary mt-1 flex-shrink-0" size={18} />
              <span className="text-sm">{location.address}</span>
            </div>
            <div className="flex items-center space-x-3">
              <Phone className="text-primary flex-shrink-0" size={18} />
              <span className="text-sm">{location.phone}</span>
            </div>
            <div className="flex items-center space-x-3">
              <Mail className="text-primary flex-shrink-0" size={18} />
              <span className="text-sm">{location.email}</span>
            </div>
            <div className="flex items-center space-x-3">
              <Clock className="text-primary flex-shrink-0" size={18} />
              <span className="text-sm">{location.hours}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default ContactLocations;
